export const CancerResultViewType = {
  Stage: 0,
  AgeAndGenders: 1
};